/* global modForm */
/**
 * Get current step
 * @returns {Object} - jQuery object of the current step
 */
export function getCurrentStep() {
	let activeStep;
	modForm.opts.steps.forEach(function(step) {
		if (step.classList.contains(modForm.opts.stepActiveCls)) {
			activeStep = step;
		}
	});
	return activeStep;
}
